import { createFileRoute } from '@tanstack/react-router'
import { CancellationPolicySettings } from '@/features/organizations/settings/cancellation-policy'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/cancellation-policy'
)({
  component: CancellationPolicySettings,
})
